export const componentsFormFileItemEn = {
  defaultImageTitle: "Image",
  unknownFileName: "Unknown file name",
  noFile: "No file",
};
